"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROUP_ROLES = void 0;
var GROUP_ROLES = {
  DISPLAY: 'DISPLAY',
  MASK: 'MASK'
};
exports.GROUP_ROLES = GROUP_ROLES;